import i18n from '../i18n'

export function getErrorMessage(errorCode: string | null | undefined, fallbackMessage?: string | null): string {
  if (errorCode) {
    const key = `errors.${errorCode}`
    const translated = i18n.t(key)
    if (translated !== key) return translated
  }
  return fallbackMessage || i18n.t('errors.INTERNAL_ERROR')
}
